export default function Button({
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  loading = false,
  disabled,
  type = 'button',
  ...props
}) {
  return (
    <button
      type={type}
      className={`aden-button aden-button--${variant} aden-button--${size} squircle-btn active:scale-[0.97] transition-[transform,background-color,border-color,box-shadow,color] duration-150 ease-out select-none ${loading ? 'is-loading opacity-75 pointer-events-none' : ''} ${className}`}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading && <span className="aden-button__spinner inline-block w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin mr-1.5" aria-hidden="true" />}
      {children}
    </button>
  )
}

export function IconButton({ label, title = label, children, className = '', type = 'button', ...props }) {
  if (!label) throw new Error('IconButton requer a propriedade label')
  return (
    <button
      type={type}
      className={`aden-icon-button squircle-btn p-2 rounded-xl text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:bg-[var(--color-surface-2)] active:scale-[0.97] transition-[transform,background-color,color] duration-150 ease-out select-none ${className}`}
      aria-label={label}
      title={title}
      {...props}
    >
      <span aria-hidden="true">{children}</span>
    </button>
  )
}
